import React from 'react';
import PropTypes from 'prop-types';

const ShapeCaption = ({ html }) =>
  html ? (
    <p
      className="caption"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  ) : (
    <></>
  );

ShapeCaption.propTypes = {
  html: PropTypes.string,
};

ShapeCaption.defaultProps = {
  html: null,
};

export default ShapeCaption;
